import React from 'react'

const PartnerTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Own", "Delivery", "Trackon", "Bluedart", "DTDC"]

  return (
    <div className='mb-5 mt-3 rounded-[24px] border border-slate-200 bg-white px-4 py-3 shadow-[0_14px_34px_rgba(15,23,42,0.06)]'>
      <div className='flex flex-wrap items-center gap-2'>
        {tabs.map((tab) => {
          const active = activeTab === tab
          return (
            <button
              key={tab}
              type='button'
              onClick={() => setActiveTab(tab)}
              className={`rounded-full px-4 py-2 text-sm font-[GilroyMedium] transition-all ${active
                ? 'bg-[#fff4ed] text-[#f97316] shadow-[inset_0_0_0_1px_rgba(249,115,22,0.14)]'
                : 'text-slate-500 hover:bg-[#fff7f2] hover:text-[#f97316]'
                }`}
            >
              {tab}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default PartnerTabs
